SupportAPIHelper = require('./helpers/API')
SupportTaglineHelper = require('./helpers/Tagline')

SupportHelpWizardController =

  intermediatePage : () ->
    activateIntermediatePage()
    Groupon.Support.HelpWizardViewManager.renderIntermediateView()

  initOrdersFetch:() ->
    activateHelpWizard()
    Backbone.history.navigate("#pick-order", { trigger: false })
    setTrackingInformation("customer_support#pick-order", window.location.href)
    Groupon.Support.HelpWizardViewManager.renderOrders()

  stepOne: (order) ->
    activateHelpWizard()
    Backbone.history.navigate("#pick-order", { trigger: false })
    setTrackingInformation("customer_support#pick-order", window.location.href)
    Groupon.Support.HelpWizardViewManager.renderOrderDetails(order)

  abruptStepTwoFlow: ->
    setDefaultSettingsForAbruptStepTwoFlow()
    @stepTwo()

  stepTwo: ->
    activateHelpWizard()
    setFlowAttributes()
    Backbone.history.navigate('#select-issue', {trigger: false})
    setTrackingInformation("customer_support#select-issue", window.location.href)
    Groupon.Support.Tagline = SupportTaglineHelper.create()
    Groupon.Support.HelpWizardViewManager.renderDropDowns()
    Groupon.Support.ContentModel.onUnloadStepOne()

  renderUserSignIn: (options) ->
    activateHelpWizard()
    Groupon.Support.HelpWizardViewManager.renderUserSignIn(options)

  stepThree: ->
    activateHelpWizard()
    setTrackingInformation("customer_support#contact-us", window.location.href)
    stepThreeView = Groupon.Support.HelpWizardViewManager.renderContactChannels()

  problemSolved: ->
    activateHelpWizard()
    setTrackingInformation("customer_support#problem-solved", window.location.href)
    Groupon.Support.HelpWizardViewManager.renderProblemSolved()

  ticketSuccess: ->
    activateHelpWizard()
    setTrackingInformation( "customer_support#ticket-success", window.location.href)
    Groupon.Support.HelpWizardViewManager.ticketSuccess()

  chatSuccess: ->
    activateHelpWizard()
    setTrackingInformation( "customer_support#chat-success", window.location.href)
    Groupon.Support.HelpWizardViewManager.chatSuccess()

  changeCurrentOrder: ( order ) ->
    Groupon.Support.currentOrder = order
    Groupon.Support.ContentModel.init(order)

window.setFlowAttributes = () ->
  return if notLandingFlow()
  if window.landingFlow is "my_account"
    Groupon.Support.ACCOUNT_RELATED = true
  else if window.landingFlow is "my_order"
    Groupon.Support.ABOUT_AN_ORDER = true

window.notLandingFlow = ->
  !window.landingFlow || oneOfFlowVariablesSet()

window.oneOfFlowVariablesSet = ->
  Groupon.Support.ACCOUNT_RELATED || Groupon.Support.ABOUT_AN_ORDER || Groupon.Support.SOMETHING_ELSE || Groupon.Support.PRE_PURCHASE

window.setDefaultSettingsForAbruptStepTwoFlow = () ->
  Groupon.Support.MAXINDEX = 2
  SupportHelpWizardController.changeCurrentOrder(null)
  Groupon.Support.ORDER_NOT_LISTED = false
  if window.isLoggedIn
    Groupon.Support.NOT_ORDER_RELATED = true

window.activateHelpWizard = ->
  $("#intermediate-page-container").hide()
  $('#contact-us-body-content').show()
  $('#footer-content').show()
  showLoading $('#help-wizard')

window.activateIntermediatePage = () ->
  $("#intermediate-page-container").show()
  $('#contact-us-body-content').hide()
  $('#footer-content').hide()

module.exports = SupportHelpWizardController
